module.exports = __webpack_public_path__ + "img/backward.320a54d1.svg";